import { useEffect, useState } from 'react';
import { useStore } from '@/store/useStore';
import { 
  isTelegramWebApp, 
  initTelegramApp, 
  getTelegramInitData,
  getTelegramUser,
  hapticFeedback
} from '@/lib/telegram';
import { detectLanguage } from '@/i18n';
import i18n from '@/i18n';
import { Loader2 } from 'lucide-react';

export function TelegramProvider({ children }) {
  const { telegramLogin, isAuthenticated, user, setLanguage } = useStore();
  const [isLoading, setIsLoading] = useState(true);
  const [isTelegram, setIsTelegram] = useState(false);

  useEffect(() => {
    const init = async () => {
      // Check if running in Telegram
      if (isTelegramWebApp()) {
        setIsTelegram(true);
        
        // Initialize Telegram Mini App
        const tg = initTelegramApp();
        console.log('Telegram Mini App initialized', tg);

        // Get user data and set language
        const tgUser = getTelegramUser();
        if (tgUser?.language_code) {
          const detectedLang = detectLanguage(tgUser.language_code);
          console.log(`Telegram language: ${tgUser.language_code} -> App language: ${detectedLang}`);
          
          // Set language in i18n and store
          i18n.changeLanguage(detectedLang);
          localStorage.setItem('language', detectedLang);
          if (setLanguage) {
            setLanguage(detectedLang);
          }
        }

        // If not authenticated, try Telegram auth
        if (!isAuthenticated) {
          const initData = getTelegramInitData();
          
          if (initData) {
            console.log('Attempting Telegram authentication...');
            const result = await telegramLogin(initData);
            
            if (result.success) {
              console.log('Telegram auth successful:', result.user);
              hapticFeedback('notification');
            } else {
              console.error('Telegram auth failed:', result.error);
            }
          }
        }
      }
      
      setIsLoading(false);
    };

    init();
  }, []);

  // Show loading screen while authenticating in Telegram
  if (isLoading && isTelegram) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-4">
          <Loader2 className="h-12 w-12 animate-spin text-primary mx-auto" />
          <p className="text-muted-foreground">加载中... / Loading...</p>
        </div>
      </div>
    );
  }

  return children;
}

export default TelegramProvider;
